import { Reducer } from 'redux';
import * as Bixby from './../../core';
import {
  UserState,
  UserActionTypes,
  USERS_LOADING,
  USERS_SUCCESS,
  USERS_FAILURE,
  UserUpdateType,
  USER_SUCCESS,
  USER_FAILURE,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAILURE,
} from './types';

import { LOGIN_CLEAR_PRELOADED_DATA } from '$/store/login/types';

const initialState: UserState = {
  isLoading: false,
  error: undefined,
  users: [],
  currentUser: undefined,
  isCreating: false,
  createError: undefined,
};

const usersReducer: Reducer<UserState> = (state = initialState, action: UserActionTypes): UserState => {
  switch (action.type) {
    case LOGIN_CLEAR_PRELOADED_DATA:
      return initialState;
    case USERS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    case USERS_SUCCESS:
      const keyofName: keyof Bixby.Models.UserSlim = 'lastName';
      const payload: Array<Bixby.Models.UserSlim> = Bixby.Utils.orderBy(
        (action.payload as Bixby.Models.UserSlim[]) || [],
        keyofName
      );
      return {
        ...state,
        isLoading: false,
        users: payload,
        error: undefined,
      };
    case USERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
        users: [],
      };
    case USER_SUCCESS: {
      const currentUser = action.payload as Bixby.Models.User | undefined;
      return {
        ...state,
        isLoading: false,
        currentUser,
        error: undefined,
      };
    }
    case USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
        currentUser: undefined,
      };
    case CREATE_USER:
      return {
        ...state,
        isCreating: true,
        createError: undefined,
      };
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        isCreating: false,
        createError: undefined,
      };
    case CREATE_USER_FAILURE:
      return {
        ...state,
        isCreating: false,
        createError: action.payload as Bixby.Models.BixbyError,
      };
    case USER_UPDATE_SUCCESS: {
      const updates = action.payload as UserUpdateType;
      const applyUpdate = (item: Bixby.Models.User) => {
        if (item.id === updates.id) {
          return { ...item, ...updates };
        }
        return item;
      };
      return {
        ...state,
        currentUser: state.currentUser && applyUpdate(state.currentUser),
        error: undefined,
      };
    }
    case USER_UPDATE_FAILURE:
      return {
        ...state,
        error: action.payload as Bixby.Models.BixbyError,
      };
    default:
      return state;
  }
};

export default usersReducer;
